import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiInstagram, FiFacebook, FiTwitter, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-primary pt-20 pb-10 border-t border-gray-900">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          <div>
            <Link to="/" className="text-2xl font-display font-bold text-light flex items-center gap-2 mb-6">
              <SafeIcon icon="Anchor" className="text-secondary" />
              BLACK ANCHOR
            </Link>
            <p className="text-muted mb-6 leading-relaxed">
              Montreal's premier tattoo studio specializing in custom artwork, precision, and unique designs crafted around your story.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-background flex items-center justify-center text-light hover:bg-secondary hover:text-primary transition-colors">
                <SafeIcon icon={FiInstagram} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-background flex items-center justify-center text-light hover:bg-secondary hover:text-primary transition-colors">
                <SafeIcon icon={FiFacebook} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-background flex items-center justify-center text-light hover:bg-secondary hover:text-primary transition-colors">
                <SafeIcon icon={FiTwitter} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-display text-light mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['Artists', 'Portfolio', 'Styles', 'Pricing', 'FAQ', 'Booking'].map(item => (
                <li key={item}>
                  <Link to={`/${item.toLowerCase()}`} className="text-muted hover:text-secondary transition-colors">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-display text-light mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-muted">
                <SafeIcon icon={FiMapPin} className="text-secondary mt-1 flex-shrink-0" />
                <span>1835 Saint Catherine Street W<br/>Montreal, QC H3H 1M2</span>
              </li>
              <li className="flex items-center gap-3 text-muted">
                <SafeIcon icon={FiPhone} className="text-secondary flex-shrink-0" />
                <span>(514) 555-1234(demo)</span>
              </li>
              <li className="flex items-center gap-3 text-muted">
                <SafeIcon icon={FiMail} className="text-secondary flex-shrink-0" />
                <span>hello@blackanchortattoo.ca(demo)</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-display text-light mb-6">Hours</h4>
            <ul className="space-y-3 text-muted">
              <li className="flex justify-between">
                <span>Tuesday - Saturday</span>
                <span>11AM - 8PM</span>
              </li>
              <li className="flex justify-between text-gray-600">
                <span>Sunday - Monday</span>
                <span>Closed</span>
              </li>
            </ul>
            <div className="mt-8 p-4 bg-background border border-gray-800 rounded">
              <p className="text-sm text-center text-muted">Walk-ins welcome based on availability. Call ahead recommended.</p>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted text-sm text-center md:text-left">
            &copy; {new Date().getFullYear()} Black Anchor Tattoo Studio. All rights reserved. Fictional demo.
          </p>
          <div className="flex gap-4 text-sm text-muted">
            <Link to="#" className="hover:text-light">Privacy Policy</Link>
            <Link to="#" className="hover:text-light">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;